import {
  Dialog,
  DialogTitle,
  List,
  ListItemButton,
  ListItemAvatar,
  Avatar,
  ListItemText,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import React from 'react';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import { useNavigate } from 'react-router-dom';
import { AnnouncementOutlined } from '@mui/icons-material';
import { useUser } from 'Providers/UserProvider';
import { logout } from 'Utils/auth';

interface IProfileModalProps {
  onConfirm: () => void;
  onClose?: () => void;
  open: boolean;
  setOpen: React.Dispatch<boolean>;
}

function ProfileModal(props: IProfileModalProps) {
  const { onClose, onConfirm, open, setOpen } = props;
  const navigate = useNavigate();

  const user = useUser();

  const handleClose = () => {
    onClose?.();
    setOpen(false);
  };

  const handleLogout = () => {
    onConfirm?.();
    handleClose();
    logout();
    navigate('/login');
  };

  const handleSubscribtionClick = () => {
    navigate('/subscriptions');
    handleClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="Profile" open={open}>
      <DialogTitle>{user.username}</DialogTitle>
      <DialogContent>
        <List>
          {!user.isClientLight && !user.isMechanic ? (
            <ListItemButton autoFocus onClick={handleSubscribtionClick}>
              <ListItemAvatar>
                <Avatar>
                  <AnnouncementOutlined />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={`Meldingen`} />
            </ListItemButton>
          ) : null}

          <ListItemButton autoFocus onClick={handleLogout}>
            <ListItemAvatar>
              <Avatar>
                <AccountCircleIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={`Log ${user.username} uit`} />
          </ListItemButton>
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Sluiten
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ProfileModal;
